import { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Centrale React-Query configuratie voor het hele app.
 *
 * Defaults zijn afgestemd op het Startburo-dashboard:
 * - `staleTime: 5 min` → bij in-app navigatie wordt cached data direct
 *   getoond zonder refetch, dus geen flash bij Dashboard → Instellingen →
 *   Dashboard.
 * - `gcTime: 30 min` → cache blijft lang genoeg in geheugen om hele
 *   sessies te overleven.
 * - `refetchOnWindowFocus: false` → voorkomt ongewenste refetches als de
 *   tab terug actief wordt (gebruiker ervaart dat als flikkering).
 * - `retry: 1` → 1 stille retry voor netwerkglitches; geen oneindige loops.
 *
 * Een echte browser-refresh (F5) leegt het geheugen sowieso en geeft dus
 * altijd verse data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

let authListenerAttached = false;

/**
 * Hangt één keer een listener aan Supabase-auth zodat de hele React-Query
 * cache wordt leeggegooid wanneer een gebruiker uitlogt. Zo kan user A nooit
 * data van user B zien wanneer ze op hetzelfde apparaat wisselen.
 */
export const attachAuthCacheReset = () => {
  if (authListenerAttached) return;
  authListenerAttached = true;

  supabase.auth.onAuthStateChange((event) => {
    if (event === "SIGNED_OUT") {
      queryClient.clear();
    }
  });
};